import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnviromentContextService } from '../services/enviroment-context-service';
import { ENVIROMENT_MODULE_CONFIG, EnviromentModuleConfig } from '../enviroment-config';

@Component({
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {

  constructor(
    @Inject(ENVIROMENT_MODULE_CONFIG) private config: EnviromentModuleConfig,
    protected enviromentContextService: EnviromentContextService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const environment = params.get("environment");
      const company = params.get("company");
      const packingStation = params.get("packingStation");
      const requestWeight = params.get("requestWeight");
      if (requestWeight !== null) {
        this.enviromentContextService.setRequestWeight(requestWeight.toLowerCase() === 'true');
      }
      const video = params.get("video");
      const videoLength = params.get("videoLength");
      const diffVersion = params.get("diffVersion");
      const integrated = params.get("integrated");
      if (company !== null && environment !== null && packingStation !== null) {
        this.enviromentContextService.setCompany(company);
        this.enviromentContextService.setEnviroment(environment);
        this.enviromentContextService.setPackingStation(packingStation);
        if (video !== null) this.enviromentContextService.setVideo(video.toLowerCase() === 'true');
        if (videoLength !== null) {
          const parsed = parseInt(videoLength, 10);
          if (!isNaN(parsed)) this.enviromentContextService.setVideoLength(parsed);
        } else {
          this.enviromentContextService.setVideoLength(5);
        }
        if (diffVersion !== null) this.enviromentContextService.setDiffVersion(diffVersion.toLowerCase() === 'true');
        if (integrated !== null)  {
          this.enviromentContextService.setIntegrated(integrated.toLowerCase() === 'true');
        } else { 
          this.enviromentContextService.setIntegrated(false);
        }
        this.router.navigateByUrl(this.config.initUrl);
      }
    });

  }

  ngOnInit(): void {
  }

}
